// extracted by mini-css-extract-plugin
module.exports = {"controls":"controls_controls__3nz9H","options":"controls_options__2ng0q","editbtn":"controls_editbtn__1hnZk","cloudtail":"controls_cloudtail__1BKK6"};